<template>
  <div>
    <transition name="ani-slide-in">
      <component v-if="!$auth.loading && !$workSessions.loading" :is="activeComponent"
                 ref="activeComponent"></component>
    </transition>
    <simple-popup
        :isVisible="display_leave_warning"
        :title="leave_title"
        :body="leave_body"
        :display_negative_btn="true"
        :custom_negative_btn_text="this.$vuetify.lang.t('$vuetify.global.no')"
        :custom_positive_btn_text="this.$vuetify.lang.t('$vuetify.global.yes')"
        @negative_btn_clicked="hide_popup()"
        @positive_btn_clicked="force_leave()"
    ></simple-popup>
  </div>

</template>
<script>
import ClientProjectSettings from "../components/modules/settings/ClientProjectSettings";
import RiskAnalysisReportComponent from "../components/modules/riskAnalysisReport/RiskAnalysisReportComponent";

import SimplePopupComponent from "../components/modules/global/simplePopup/SimplePopupComponent";
import CapSaveStateInvalidatorMixin from "../mixins/capSettings/CapSaveStateInvalidatorMixin";
import authMixin from "@/auth/sanctum/mixins/authMixin";
import WSReliantComponentMixin from "@/workSessions/mixins/WSReliantComponentMixin";

const rarComp = 'rARComponent'
const cpSettings = 'cPSettings'

export default {
  name: "RiskAnalysisReport",
  data: () => {
    return {
      user_agreed_to_skip: false,
      display_leave_warning: false,
      leave_title: '',
      leave_body: '',
      go_to_path: '/'
    }
  },
  components: {
    cPSettings: ClientProjectSettings,
    rARComponent: RiskAnalysisReportComponent,
    //DO NOT USE THIS ONE AS CURRENT COMP !!!!!!
    simplePopup: SimplePopupComponent
  },
  methods: {
    force_leave() {
      this.hide_popup();
      this.user_agreed_to_skip = true;
      this.$router.replace(this.go_to_path);
    },
    hide_popup() {
      this.display_leave_warning = false;
    }
  },
  computed: {
    activeComponent() {
      if (this.hasValidWorkSession || this.$store.state.capsSaveValidated) {
        return rarComp
      }
      return cpSettings
    }
  },
  mixins: [CapSaveStateInvalidatorMixin, authMixin, WSReliantComponentMixin],
  created() {
    //DISPATCH LOCATION GRAB
    this.leave_title = this.$vuetify.lang.t('$vuetify.risk_analysis.leave_warning.risk_default.title');
    this.leave_body = this.$vuetify.lang.t('$vuetify.risk_analysis.leave_warning.risk_default.body');

    this.$store.dispatch('getUserLocation');
  },
  beforeRouteLeave(to, from, next) {
    if (this.activeComponent === rarComp) {
      try {
        //ONLY THIS ONE HAS CAN LEAVE PART!!
        if (!this.$refs.activeComponent.doCanLeaveCheck() && !this.user_agreed_to_skip) {
          try {
            this.leave_title = this.$refs.activeComponent.getLeaveWarningTitle();
            this.leave_body = this.$refs.activeComponent.getLeaveWarningBody();
          } catch ($tbe) {
            //BUMMER...
            //FALLBACK IS PROVIDED ANYWAY...
          }
          this.display_leave_warning = true;
          this.go_to_path = to.path;
        } else {
          next();
        }
      } catch ($e) {
        next();
      }

    }

    if (this.activeComponent === cpSettings) {
      next();
    }
  }
}
</script>